// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14PKa","col":"styles_col__1xMUt"};